// extracted by mini-css-extract-plugin
export default {"cls1":"VURWnhTG2zBazWpoj1mT","cls2":"XAVi1NbEAatiXYHkhWfD VURWnhTG2zBazWpoj1mT"};